module.exports = __webpack_public_path__ + "static/media/release-info1.6500a882.png";